import React, { createContext, useContext, useEffect } from 'react'
import {
    WagmiProvider,
    createConfig,
    http,
    useAccount,
    useConnect,
    useDisconnect,
} from 'wagmi'
import { mainnet, bscTestnet, bsc } from 'wagmi/chains'
import { injected, walletConnect, metaMask } from 'wagmi/connectors'
//import { walletConnect } from '@wagmi/connectors/walletConnect'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { defineChain } from 'viem';
import { toastAlert } from '../../helper/toastAlert'

const disableAuto = localStorage.getItem("disableAutoConnect") === "true";
const customBsc = defineChain({
    id: 56,
    name: 'Binance Smart Chain',
    network: 'bsc-mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'BNB',
        symbol: 'BNB',
    },
    rpcUrls: {
        default: { http: ['https://bsc-dataseed.binance.org/'] },
    },
    blockExplorers: {
        default: { name: 'BscScan', url: 'https://bscscan.com' },
    },
});



const config = createConfig({
    autoConnect: !disableAuto,
    chains: [bsc, bscTestnet],
    transports: {
        [bsc.id]: http('https://bsc-dataseed.binance.org/'),
        [bscTestnet.id]: http('https://bsc-dataseed.binance.org/'),
    },
    connectors: [
        metaMask({ chains: [bsc, bscTestnet] }),
        walletConnect({
            projectId: 'cb89ebb21cdccb2e1b591e189e27706a',
            chains: [bsc, bscTestnet],
            showQrModal: true,
        }),
    ],
});

if (disableAuto) {
    localStorage.removeItem("disableAutoConnect");
}
const queryClient = new QueryClient()

const WalletContext = createContext(null)

export const WalletProvider = ({ children }) => {
    return (
        <WagmiProvider config={config}>
            <QueryClientProvider client={queryClient}>
                <WalletProviderInner>{children}</WalletProviderInner>
            </QueryClientProvider>
        </WagmiProvider>
    )
}

const WalletProviderInner = ({ children }) => {
    const address = useAccount()
    const { connect, connectors } = useConnect()
    const { disconnectAsync } = useDisconnect()
    useEffect(() => {
        const storedWallet = localStorage.getItem("rememberedEmail");

        // ✅ First-time connection — store it
        if (address.isConnected && address.address && !storedWallet) {
            localStorage.setItem("rememberedEmail", address.address.toLowerCase());
        }

        if (
            address.isConnected &&
            storedWallet &&
            address.address &&
            storedWallet.toLowerCase() !== address.address.toLowerCase()
        ) {
            toastAlert(
                "error",
                "Wallet address changed. Please reconnect with your original wallet."
            );

            setTimeout(async () => {
                try {
                    await disconnectAsync();
                } catch (err) {
                    console.error("Disconnect error:", err);
                }

                localStorage.clear();
                localStorage.setItem("disableAutoConnect", "true");
                window.location.href = "/";
            }, 1000);
        }
    }, [address.address, address.isConnected, disconnectAsync]);

    return (
        <WalletContext.Provider
            value={{
                ...address,
                connectors,
                connectWallet: (connector) => connect({ connector }),
                disconnectWallet: disconnectAsync,
            }}
        >
            {children}
        </WalletContext.Provider>
    )
}


export const useWallet = () => useContext(WalletContext)
